module.exports = __webpack_public_path__ + "img/geofence.063035eb.svg";